export const handleAnalytics =
  ({ dispatch }) =>
  (next) =>
  (action) => {
    next(action);
  };
